export default {
  mounted(el) {
    let isComposing = false;
    let lastContent = '';

    el.addEventListener('input', () => {
      if (!isComposing) {
        const selectionRange = saveSelection();
        highlightText(el);
        restoreSelection(selectionRange);
        lastContent = el.innerHTML;
      }
    });

    el.addEventListener('compositionstart', () => {
      isComposing = true;
    });

    el.addEventListener('compositionend', () => {
      isComposing = false;
      const selectionRange = saveSelection();
      highlightText(el);
      restoreSelection(selectionRange);
      lastContent = el.innerHTML;
    });

    // Initialize the content with highlighted text
    highlightText(el);
  },
};

const saveSelection = () => {
  const sel = window.getSelection();
  if (sel.rangeCount > 0) {
    return sel.getRangeAt(0);
  }
  return null;
};

const restoreSelection = (range) => {
  if (range) {
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }
};

const highlightText = (el) => {
  const content = el.innerHTML;
  const highlightedText = content.replace(/{([^}]+)}/g, '<span class="highlight">$1</span>');
  el.innerHTML = highlightedText;
};
